"use strict";

var _useViewerAccountQuery;
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
export const useViewerAccount = () => {
  const {
    viewer
  } = useLazyLoadQuery(_useViewerAccountQuery !== void 0 ? _useViewerAccountQuery : _useViewerAccountQuery = require("../relay/__generated__/useViewerAccountQuery.graphql"), {}, {
    fetchPolicy: 'store-or-network'
  });
  return viewer;
};